import React from "react";
import { observer } from "mobx-react";
import { LineItemElementProps } from "../types";
import getMappingToolStore from "../../MappingTool/data/MappingToolStore";

export const LineItemOverrideOption: React.FC<{ onGroupClicked?: (group: string[]) => void; lineItemToProcess: LineItemElementProps[] }> = observer(
	({ lineItemToProcess, onGroupClicked }) => {
		const mappingToolStore = getMappingToolStore();

		return (
			<>
				{lineItemToProcess.map((element, ind) => {
					return (
						<React.Fragment key={ind}>
							<div className="grow shrink p-1 bg-white flex-col justify-start items-start gap-2 flex ">
								{element.type === "variable" ? (
									[
										<select
											key={`${ind}-0`}
											value={mappingToolStore.getOverrideDefaultValue(element.value) ?? ""}
											onChange={(e) => {
												mappingToolStore.setOverrideDefaultValue(element.value, e.target.value);
											}}
										>
											{["", ...(element.acceptableValues ?? []), element.allowEmptyValue ? "empty value" : null].map((value, i) => {
												if (value === null) return null;
												return (
													<option
														key={i}
														onClick={() => {
															onGroupClicked && onGroupClicked(element.acceptableValues!);
														}}
													>
														<div className={`self-stretch text-slate-600 text-base font-['Hanken Grotesk'] leading-normal`}>
															{value}
														</div>
													</option>
												);
											})}
										</select>,
									]
								) : (
									<>
										<div className="self-stretch justify-start items-start gap-3 inline-flex">
											<div className="grow shrink basis-0 flex-col justify-start items-start inline-flex">
												<div className="self-stretch text-gray-400 text-base font-normal font-['Hanken Grotesk'] leading-normal no-break">
													{element.value}
												</div>
											</div>
										</div>
									</>
								)}
							</div>
							{ind !== lineItemToProcess.length - 1 && <img src="/assets/ui/divider.svg" className="w-6 h-32 relative" />}
						</React.Fragment>
					);
				})}
			</>
		);
	}
);
